var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"price__helper-truck"},[_c('div',{staticClass:"price__desc"},[_c('p',[_vm._v(_vm._s(_vm.tabDescription))])])])}
var staticRenderFns = []

export { render, staticRenderFns }